const DOCUMENT_PROTOCOLS = new Set(['app:', 'https:', 'http:'])

/**
 * Absolute URL of the signed-out shell for the page the window is on.
 * Keeps the origin and drops the path, so a chunk URL cannot be reloaded
 * as the document.
 */
export function desktopSignedOutUrl(pageUrl: string): string {
  let url: URL
  try {
    url = new URL(pageUrl)
  } catch {
    return 'app://studio/'
  }
  if (!DOCUMENT_PROTOCOLS.has(url.protocol)) {
    return 'app://studio/'
  }
  url.pathname = '/'
  url.search = ''
  url.hash = ''
  return url.href
}
